export class ResolveConflictsPayload {

    public reportId: string;
    public controlNumber: string;
    public controlGroups: ResolveConflictsControlGroup[];
}

export class ResolveConflictsEntry {
    public quantities: (number | null)[];
}

export class ResolveConflictsControlGroup {
    public partNumber: string;
    public entry1: ResolveConflictsEntry;
    public entry2: ResolveConflictsEntry;
}

// What the screens hold of a conflict, horizontal or vertical: the part, and the quantities of both entries.
export interface ResolvableConflict {
    partNumber: string;
    entry1: { getQuantities(): (number | null)[] };
    entry2: { getQuantities(): (number | null)[] };
}

// Written as typed objects, not cast with "as": the part number is part of what the server needs of each control
// group, and one left out (or put beside the control groups) must not compile, as the server would add a part
// that has quantities and no part number.
export function toResolveConflictsControlGroup(conflict: ResolvableConflict): ResolveConflictsControlGroup {
    return {
        partNumber: conflict.partNumber,
        entry1: { quantities: conflict.entry1.getQuantities() },
        entry2: { quantities: conflict.entry2.getQuantities() }
    };
}

export function createResolveConflictsPayload(reportId: string, controlNumber: string, conflicts: ResolvableConflict[]): ResolveConflictsPayload {
    return {
        reportId,
        controlNumber,
        controlGroups: conflicts.map(toResolveConflictsControlGroup)
    };
}
